import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";
import moment from "moment/moment";
import DatePicker from "react-date-picker";
import Loader from "../../shared/loader";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";
import Pagination from "../../shared/pagination";

const Payment = () => {
  const contentToPrint = useRef(null);
  const [paymentData, setPaymentData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCustomPrint, setIsCustomPrint] = useState(true);
  const [partyId, setPartyId] = useState(0);
  const [salesManDrp, setSalesManDrp] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchParam] = useState(["date"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 30;
  const selectRef = useRef();

  const getSalesManData = () => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [0,1]}).then((res) => {
      if (res?.data?.data?.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            label: raw.name + " - " + raw.contact_no,            
            value: raw.id,
          };
        });
        setSalesManDrp(pt);
      }
    });
  };

  const searchDataByDate = (fromDate, toDate) => {
    if (fromDate && toDate) {
      setCurrentPage(1);
      getData(partyId, fromDate, toDate, 1);
    }
  };

  const customPrint = () => {
    setIsCustomPrint(false);
  };

  const clearFilter = () => {
    setLoading(false);
    setStartDate(null);
    setEndDate(null);
    setPaymentData([]);
    setCurrentPage(1);
    setTotalPages(1);
    setTotalCount(0);
    setTimeout(() => {
      selectRef.current.clearValue();
    }, 200);
  };

  const getData = (party_id, from_date, to_date, page = 1) => {
    let params = {
      party_id: party_id,
      from_date: from_date ? moment(from_date).format("YYYY-MM-DD") : null,
      to_date: to_date ? moment(to_date).format("YYYY-MM-DD") : null,
      page: page,
      limit: itemsPerPage,
    };
    setLoading(true);
    axios.post(API_URL.PAYMENT_LIST, params).then(
      (res) => {
        if (res.data.status === 1) {
          setPaymentData(res.data.data.data);
          const total = res.data.data.total || 0;
          setTotalPages(Math.ceil(total / itemsPerPage));
          setTotalCount(total);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deleteData = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Payments",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PAYMENT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success(row.party_name + " Delete Successfully", { autoClose: 3000 });
              getData(partyId, startDate, endDate, currentPage); // reload current page
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  const searchData = (items) => {
    return items.filter((item) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem] &&
          item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) > -1
        );
      });
    });
  };

  const handlePrint = useReactToPrint({
    documentTitle: "",
    onBeforePrint: () => {
      console.log("before printing...");
    },
    onAfterPrint: () => {
      setIsCustomPrint(true);
    },
    removeAfterPrint: true,
  });
  useEffect(() => {
    !isCustomPrint && handlePrint(null, () => contentToPrint.current);
  }, [isCustomPrint]);

  useEffect(() => {
    if (partyId && partyId > 0) {
      setCurrentPage(1);
      getData(partyId, startDate, endDate, 1);
    }
  }, [partyId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getData(partyId, startDate, endDate, page);
  };

  useEffect(() => {
    getSalesManData();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Payments
          </h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/payments/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
              Add Payment
            </Link>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <Select
              ref={selectRef}
              placeholder={"Select Sales Man"}
              value={salesManDrp.find((pt) => pt.value == partyId)}
              options={salesManDrp}
              onChange={(e) => setPartyId(e ? e.value : 0)}
            />
          </div>
        </div>
        <div className="col-md-3 mb-3 col-sm-12">
          <div className="form-group">
            <DatePicker
              placeholderText="From Date"
              dateFormat="dd/MM/yyyy"
              className="form-control input-sm"
              selected={startDate}
              onChange={(date) => [
                setStartDate(date),
                searchDataByDate(date, endDate),
              ]}
              value={startDate}
            />
          </div>
        </div>
        <div className="col-md-3 mb-3 col-sm-12">
          <div className="form-group">
            <DatePicker
              placeholderText="To Date"
              dateFormat="dd/MM/yyyy"
              className="form-control input-sm"
              selected={endDate}
              onChange={(date) => [
                setEndDate(date),
                searchDataByDate(startDate, date),
              ]}
              value={endDate}
            />
          </div>
        </div>
        <div className="col-md-3 col-sm-12 text-end">
          {/* <button
            type="button"
            disabled={!partyId || !paymentData.length}
            className="btn btn-info me-2"
            onClick={() => customPrint()}
          >
            Download
          </button> */}
          {(partyId || startDate || endDate) && (
            <button
              type="button"
              className="btn btn-dark"
              onClick={clearFilter}
            >
              Clear Filter
            </button>
          )}
        </div>
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading ? (
                <Loader></Loader>
              ) : (
                <div>
                  <div className="table-responsive" ref={contentToPrint}>
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th className="index-th">#</th>
                          <th styles={{ height: "36px" }}>Date</th>
                          <th>Party</th>
                          <th>Total Amount</th>
                          {isCustomPrint ? (
                            <th className="action-th">Action</th>
                          ) : null}
                        </tr>
                      </thead>
                      <tbody>
                        {searchData(paymentData).map((row, key) => {
                          return (
                            <tr key={key} style={{ height: "40px" }}>
                              <td className="index-td">{(currentPage - 1) * itemsPerPage + key + 1}</td>
                              <td>
                                {moment(row.date, "YYYY-MM-DD").format(
                                  "DD-MM-YYYY"
                                )}
                                {row.payment_view == "Direct"
                                  ? ""
                                  : " - " + row.payment_view}
                              </td>
                              <td>{row.party_name}</td>
                              <td>${row.amount}</td>

                              <td className="action-td">
                                <>
                                  {row.payment_view === "Direct" && (
                                    <Link to={"/payments/edit/" + row.id}>
                                      <button className="btn btn-sm btn-primary mr-2">
                                        <i className="fa fa-edit me-1"></i> Edit
                                      </button>
                                    </Link>
                                  )}
                                  <button
                                    onClick={() => deleteData(row)}
                                    className="btn btn-sm btn-danger me-2"
                                  >
                                    <i className="fa fa-trash me-1"></i>{" "}
                                    Delete
                                  </button>
                                </>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center my-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Payment;
